export enum Message {
  SUCCESS = 'Operação realizada com sucesso',
  AUTHORIZATION = 'Sua sessão expirou',
  FAILURE = 'Tivemos um probelma ao realizar operação',
}
